import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { ExpandMore } from "@mui/icons-material"
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material"
import { percentageFormatter } from "helpers/formatters/numbers"
import { treatAsFactor } from "helpers/securities"
import { TRADE } from "../../shapes"
import "./styles.scss"

class Trades extends Component {
  static propTypes = {
    trade: TRADE.isRequired,
    openTradeId: PropTypes.string,
    setOpenTradeId: PropTypes.func.isRequired,
    openFactorProfile: PropTypes.func.isRequired,
    openSecurityProfile: PropTypes.func.isRequired,
    openCompositeSecurity: PropTypes.func.isRequired,
  }

  onClick = event => {
    event.stopPropagation()
    const { trade: { ticker, mic, assetClass }, openSecurityProfile, openFactorProfile, openCompositeSecurity } = this.props

    if (treatAsFactor(assetClass)) {
      openFactorProfile(ticker)
    } else if (assetClass === "index") {
      openCompositeSecurity({ type: assetClass, id: ticker })
    } else {
      openSecurityProfile(mic, ticker)
    }
  }

  onChange = () => {
    const { trade: { key }, setOpenTradeId } = this.props
    setOpenTradeId(key)
  }

  render() {
    const { trade: { label, tradePercentDelta, key, securityPercentEquity: originalPercentEquity }, openTradeId } = this.props
    const percentValue = percentageFormatter(Math.abs(tradePercentDelta))

    return <Accordion className="trade" expanded={key === openTradeId} onChange={this.onChange}>
      <AccordionSummary expandIcon={<ExpandMore />} classes={{ expanded: "expanded-trade" }}>
        <a className="security" onClick={this.onClick}>{label}</a>
        <div className={classnames("percent", {
          negative: tradePercentDelta < 0 && percentValue !== "0.00%",
        })}
        >
          {percentValue}
        </div>
      </AccordionSummary>
      <AccordionDetails className="options">
        <div className="trade-equity-label">Original % Equity</div>
        <div className="trade-equity">{percentageFormatter(originalPercentEquity)}</div>
      </AccordionDetails>
    </Accordion>
  }
}

export default Trades
